// css
import "assets/css/style.css";
// slick slider css
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// 
import AppRouter from "config/AppRouter";
import { auth } from "config/firebase";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
//
import { setAuth } from "redux/reducers/authReducerSlice";
import axios from "axios";
import ScrollTop from "utils/ScrollTop";


function App() {
  const dispatch = useDispatch();

  // check already loggedIn user
  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      if (user) {
        user
          .getIdToken()
          .then(function (idToken) {
            // console.log(user)
            // console.log(idToken)
            axios({
              method: "GET",
              url: `${process.env.REACT_APP_MAMAZEN_API_BASE_URL}me`,
              headers: {
                "Authorization": idToken,
                "token_type": "firebase"
              },
            })
              .then((res) => {
                // console.log("User is loggedIn",res);
                dispatch(
                  setAuth({
                    data: res.data,
                    isAuthenticated: true,
                    isLoading: false,
                  })
                );
              })
              .catch((err) => {
                console.log(err);
              });
          })
          .catch(function (error) {
            // Handle error
            console.log(error);
          });
      }else{
        dispatch(
          setAuth({
            data: {},
            isAuthenticated: false,
            isLoading: false,
          })
        );
      }
    });
  }, []);
  

  
  return (
    <>
      <AppRouter />
      {/* <footer className="copyright_area">
        <div className="cs_container footer">
          <div className="copyright_text">
            <span>
              Copyright © <span id="year"></span>, All Right Reserved
              <a
                className="a-white"
                href="https://www.smashcode.dev"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                Smash Code
              </a>
            </span>
          </div>
        </div>
      </footer> */}
      <ScrollTop/>
    </>
  );
}

export default App;
